// Thin progress bar for the compose "Write message" add flow. Extracted from
// GlobalSearchModal to keep that component under the file-size limit.
export function ProgressBar({ progress }: { progress: number }) {
	return (
		<div className="w-full h-2 bg-brand-white rounded-full">
			<div className="h-full bg-blue-action rounded-full" style={{ width: `${progress}%` }}></div>
		</div>
	);
}
